import React from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

export default function AffiliateSlider() {
  const sliderConfigs = [
    { label: 'DocsAutomator 200', price: 19, state: React.useState(3) },
    { label: 'DocsAutomator 500', price: 34, state: React.useState(2) },
    { label: 'DocsAutomator 2000', price: 89, state: React.useState(1) },
    { label: 'DocsAutomator 5000', price: 169, state: React.useState(1) },
  ];

  const [cashValue, setCashValue] = React.useState(0);

  React.useEffect(
    () => {
      const totalValue = sliderConfigs.reduce((acc, { price, state }) => {
        const [value] = state;
        return acc + value * price * 12 * 0.3;
      }, 0);
      setCashValue(totalValue.toFixed(0));
    },
    sliderConfigs.map(({ state }) => state[0])
  );

  return (
    <>
      <h2 className="text-3xl font-bold pb-8 text-indigo-950">
        Earn{' '}
        <span className="text-extrabold text-emerald-600">
          ${String(cashValue)}{' '}
        </span>
        per year
      </h2>
      {sliderConfigs.map(({ label, price, state }, index) => {
        const [sliderValue, setSliderValue] = state;
        return (
          <div
            key={index}
            className={`flex gap-4 items-center ${index > 0 && 'mt-4'}`}
          >
            <div className="w-12 h-12 bg-slate-200 rounded-xl flex justify-center items-center shrink-0">
              <span className="font-bold text-indigo-950">{sliderValue}x</span>
            </div>
            <label className="font-bold min-w-48 leading-none text-indigo-950">
              {label} <br />
              <span className="text-xs font-normal text-indigo-950">
                (${price.toFixed(2)} / month)
              </span>
            </label>
            <Slider
              value={sliderValue}
              onChange={setSliderValue}
              max={25}
              min={0}
              handleStyle={{
                backgroundColor: '#fff',
                opacity: '1',
                borderColor: '#4f46e5',
                height: '18px',
                width: '18px',
                hover: {
                  borderColor: 'red',
                },
              }}
              trackStyle={{ backgroundColor: '#4f46e5', height: '8px' }}
              railStyle={{ backgroundColor: '#e2e8f0', height: '8px' }}
              style={{ height: '28px', padding: '6px 0' }}
            />
          </div>
        );
      })}
    </>
  );
}
